import axios from 'axios';
import { API_BASE_URL } from '../config/api';

// Configuration d'Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Erreur API:', error);
    return Promise.reject(error);
  }
);

// Services pour les Groupes
export const groupeService = {
  getAll: () => api.get('/groupes'),
  getById: (id) => api.get(`/groupes/${id}`),
  create: (groupe) => api.post('/groupes', groupe),
  update: (id, groupe) => api.put(`/groupes/${id}`, groupe),
  delete: (id) => api.delete(`/groupes/${id}`),
};

// Services pour les Agents
export const agentService = {
  getAll: (params = {}) => {
    // Nettoyer les paramètres pour éviter d'envoyer des valeurs vides
    const cleanParams = {};
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value !== '' && value !== null && value !== undefined) {
        // Pour les paramètres boolean, s'assurer qu'ils sont envoyés correctement
        if (typeof value === 'boolean') {
          cleanParams[key] = value;
        } else {
          cleanParams[key] = value;
        }
      }
    });
    return api.get('/agents', { params: cleanParams });
  },
  getById: (id) => api.get(`/agents/${id}`),
  create: (agent) => api.post('/agents', agent),
  update: (id, agent) => api.put(`/agents/${id}`, agent),
  delete: (id) => api.delete(`/agents/${id}`),
  uploadPhoto: (id, formData) => 
    api.post(`/agents/${id}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  deletePhoto: (id) => api.delete(`/agents/${id}/photo`),
  getFonctions: () => api.get('/agents/fonctions'),
  getStatsParFonction: () => api.get('/agents/stats-par-fonction'),
};

// Services pour les Cartes de Pointage
export const cartePointageService = {
  genererCarteAgent: (agentId, mois, annee) => 
    api.get(`/cartes-pointage/agent/${agentId}?mois=${mois}&annee=${annee}`),
  genererCartesGroupe: (groupeId, mois, annee) => 
    api.get(`/cartes-pointage/groupe/${groupeId}?mois=${mois}&annee=${annee}`),
  genererCartesFonction: (fonction, mois, annee) => 
    api.get(`/cartes-pointage/fonction/${encodeURIComponent(fonction)}?mois=${mois}&annee=${annee}`),
  genererToutesLesCartes: (mois, annee) => 
    api.get(`/cartes-pointage/toutes?mois=${mois}&annee=${annee}`),
  genererCartesAvecFiltres: (mois, annee, filters = {}) => {
    const params = new URLSearchParams({ mois, annee });
    
    if (filters.agentIds?.length) {
      filters.agentIds.forEach(id => params.append('agentIds', id));
    }
    if (filters.groupeIds?.length) {
      filters.groupeIds.forEach(id => params.append('groupeIds', id));
    }
    if (filters.fonctions?.length) {
      filters.fonctions.forEach(f => params.append('fonctions', f));
    }
    
    return api.get(`/cartes-pointage/batch?${params}`);
  },
};

export default api; 